import i18next from 'i18next';
import isEmpty from 'lodash/isEmpty';

import { bulkArchiveCredits } from 'common/api/creditApplications';
import alerts from 'common/modules/alerts';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import {
    BULK_UPDATE_ITEMS,
    BULK_UPDATE_ITEMS_FAILURE,
    BULK_UPDATE_ITEMS_SUCCESS,
} from '../actionTypes';
import { creditsActions } from '../reducer';

import filterCredits from './filterCredits';

export default (ids, value, filterData = {}, callback = null) =>
    (dispatch) => {
        dispatch(creditsActions[BULK_UPDATE_ITEMS]());

        bulkArchiveCredits({ ids, is_archived: value })
            .then(() => {
                dispatch(creditsActions[BULK_UPDATE_ITEMS_SUCCESS]());
                if (!isEmpty(filterData)) dispatch(filterCredits(filterData));
                if (value === 'archived')
                    showToast({ body: i18next.t('Archived successfully') });
                if (value === 'active')
                    showToast({ body: i18next.t('Unarchived successfully') });
                dispatch(alerts.actions.close());
                if (callback) callback();
            })
            .catch((error) => {
                dispatch(
                    creditsActions[BULK_UPDATE_ITEMS_FAILURE](
                        error?.response?.data?.errors,
                    ),
                );
                showReponseErrorsAsAlert(dispatch, error?.response);
            });
    };
